"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _TextArea = _interopRequireDefault(require("../TextArea"));
var _ReviewComments = _interopRequireDefault(require("./ReviewComments.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ReviewCommentsContainer = _styledComponents.default.div.withConfig({
  displayName: "ReviewComments__ReviewCommentsContainer",
  componentId: "sc-1a8f373-0"
})(["display:flex;flex-direction:column;"]);
var TextAreaContainer = _styledComponents.default.div.withConfig({
  displayName: "ReviewComments__TextAreaContainer",
  componentId: "sc-1a8f373-1"
})(["padding-top:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.XSmall;
});
var ReviewComments = function ReviewComments(props) {
  var title = props.title,
    subtitle = props.subtitle,
    label = props.label,
    theme = props.theme,
    onChangeHandler = props.onChangeHandler,
    onReviewChangeHandler = props.onReviewChangeHandler,
    accessible = props.accessible,
    showError = props.showError,
    showReviewError = props.showReviewError,
    reviewTitle = props.reviewTitle,
    reviewSubtitle = props.reviewSubtitle,
    reviewLabel = props.reviewLabel,
    validationMessage = props.validationMessage,
    reviewValidationMessage = props.reviewValidationMessage,
    isMobile = props.isMobile,
    customTitleBoxHeight = props.customTitleBoxHeight,
    customReviewBoxHeight = props.customReviewBoxHeight,
    customProperties = props.customProperties,
    spanLabel = props.spanLabel,
    reviewSpanLabel = props.reviewSpanLabel;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var titleBoxHeight = isMobile ? _constant.TITLEBOX_HEIGHT.MOBILE : _constant.TITLEBOX_HEIGHT.DESKTOP;
  var reviewBoxHeight = isMobile ? _constant.REVIEWBOX_HEIGHT.MOBILE : _constant.REVIEWBOX_HEIGHT.DESKTOP;
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ReviewCommentsContainer, customProperties, (title || subtitle || label) && /*#__PURE__*/_react.default.createElement(TextAreaContainer, null, /*#__PURE__*/_react.default.createElement(_TextArea.default, {
      overflow: _constant.TEXTAREA_OVERFLOW,
      title: title,
      subtitle: subtitle,
      label: label,
      validateMessage: validationMessage,
      validateStatus: showError ? _constant.VALIDATION_ERROR : null,
      height: customTitleBoxHeight || titleBoxHeight,
      onChange: onChangeHandler,
      accessible: accessible,
      spanText: spanLabel
    })), (reviewTitle || reviewSubtitle || reviewLabel) && /*#__PURE__*/_react.default.createElement(TextAreaContainer, null, /*#__PURE__*/_react.default.createElement(_TextArea.default, {
      overflow: _constant.TEXTAREA_OVERFLOW,
      title: reviewTitle,
      subtitle: reviewSubtitle,
      label: reviewLabel,
      validateMessage: reviewValidationMessage,
      validateStatus: showReviewError ? _constant.VALIDATION_ERROR : null,
      height: customReviewBoxHeight || reviewBoxHeight,
      onChange: onReviewChangeHandler,
      accessible: accessible,
      spanText: reviewSpanLabel
    })));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
ReviewComments.propTypes = _ReviewComments.default.PropTypes;
ReviewComments.defaultProps = _ReviewComments.default.DefaultProps;
var _default = ReviewComments;
exports.default = _default;